import { TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import React from 'react';

const EnderecoVisualizar = ({ endereco }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextLabel label="CEP" value={endereco?.cep} />
      </Grid>

      <Grid item xs={12}>
        <TextLabel label="Logradouro" value={endereco?.logradouro} />
      </Grid>

      <Grid item xs={6}>
        <TextLabel label="Número" value={endereco?.numero} />
      </Grid>

      <Grid item xs={6}>
        <TextLabel label="Complemento" value={endereco?.complemento} />
      </Grid>

      <Grid item xs={12}>
        <TextLabel label="UF" value={endereco?.uf?.sigla} />
      </Grid>

      <Grid item xs={12}>
        <TextLabel label="Cidade" value={endereco?.cidade?.nome} />
      </Grid>

      <Grid item xs={6}>
        <TextLabel label="Bairro" value={endereco?.bairro} />
      </Grid>

      <Grid item xs={6}>
        <TextLabel label="Referência" value={endereco?.referencia} />
      </Grid>
    </Grid>
  );
};

export default EnderecoVisualizar;
